<template>
  <div class="portada-arley" ref="contenedorXV" aria-label="Baptism Thanksgiving">
    <div class="fondo-gradiente">
      <div class="fondo-arco"></div>
    </div>

    <div class="onda-luz-bg"></div>

    <img src="@/assets/brillo.avif" class="brillo brillo-izq-1" alt="" />
    <img src="@/assets/brillo.avif" class="brillo brillo-izq-2" alt="" />
    <img src="@/assets/brillo.avif" class="brillo brillo-der-1" alt="" />
    <img src="@/assets/brillo.avif" class="brillo brillo-der-2" alt="" />

    <img src="@/assets/mariposaa.png" class="flor-grande flor-der-1" alt="" />

    <div class="bloque-agradecimiento-editorial">
      <!-- 1. Original text of gratitude to parents -->
      <p class="texto-gratitud-padres item-animable">
        With love and gratitude to my parents, whose care and support have made this special moment possible for me.
      </p>

      <img src="@/assets/sepp.avif" class="separador-vintage-center item-animable" aria-hidden="true" alt="" />

      <!-- 2. Original names of the parents -->
      <div class="bloque-nombres-padres">
        <h2 class="nombre-caligrafico item-animable">
          Mauricio
        </h2>
        <span class="conector-and item-animable">&</span>
        <h2 class="nombre-caligrafico item-animable">
          Elba Mendoza
        </h2>
      </div>
        <br>   <br>
      <img src="@/assets/sepp.avif" class="separador-vintage-center item-animable" aria-hidden="true" alt="" />

      <!-- 3. Baptism Godparents with consecutive animation -->
      <div class="bloque-padrinos-bautizo">
        <h3 class="titulo-padrinos item-animable">My Baptism Godparents</h3>
        <h2 class="nombre-caligrafico item-animable">
          Humberto
        </h2>
        <span class="conector-and item-animable">&</span>
        <h2 class="nombre-caligrafico item-animable">
          Ruti García
        </h2>
      </div>
    </div>

  </div>
</template>

<script>
import { onMounted, ref, nextTick, onUnmounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const contenedorXV = ref(null)
    let observadorGlobal = null
    let contextoGsap = null

    onMounted(async () => {
      await nextTick()
      if (!contenedorXV.value) return

      const $ = gsap.utils.selector(contenedorXV.value)

      const fondo = $('.fondo-gradiente')
      const arco = $('.fondo-arco')
      const itemsAnimables = $('.item-animable')
      const floresGrandes = $('.flor-grande')
      const brillos = $('.brillo')

      // Configuración de estados iniciales controlados
      const totalElementos = [].concat(fondo, arco, itemsAnimables, floresGrandes, brillos)
      gsap.set(totalElementos, { autoAlpha: 0, y: 35 })
      gsap.set(brillos, { scale: 0 })

      observadorGlobal = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          contextoGsap = gsap.context(() => {
            const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

            // 1. Entrada de fondo y arquitectura del arco
            tl.to(fondo, { autoAlpha: 1, y: 0, duration: 0.9 })
              .to(arco, { autoAlpha: 1, y: 0, duration: 0.8 }, '-=0.5')

            // 2. Animación GSAP consecutiva (stagger) para todos los textos y elementos del centro
            tl.to(itemsAnimables, {
              autoAlpha: 1,
              y: 0,
              duration: 0.9,
              stagger: 0.15
            }, '-=0.3')

            // 3. Flores laterales con rotación orgánica controlada
            tl.to(floresGrandes, {
              autoAlpha: 1,
              y: 0,
              rotate: () => gsap.utils.random(-5, 5),
              duration: 0.9,
              stagger: 0.12
            }, '-=0.5')

            // 4. Encendido e inicio de bucle infinito para brillos
            tl.to(brillos, {
              autoAlpha: 1,
              scale: 1,
              duration: 0.8,
              stagger: 0.15,
              onComplete: () => {
                gsap.to(brillos, {
                  opacity: 0.6,
                  scale: 1.12,
                  duration: 1,
                  repeat: -1,
                  yoyo: true,
                  ease: 'sine.inOut'
                })
              }
            }, '-=0.4')

            // Bucle flotante orgánico para las flores
            floresGrandes.forEach((flor, i) => {
              if (!flor) return
              gsap.to(flor, {
                y: `+=${gsap.utils.random(4, 9)}`,
                x: `+=${gsap.utils.random(-4, 4)}`,
                rotation: `+=${gsap.utils.random(-1, 1)}`,
                duration: gsap.utils.random(3.2, 4.8),
                repeat: -1,
                yoyo: true,
                ease: 'sine.inOut',
                delay: i * 0.1
              })
            })

          }, contenedorXV.value)

          observadorGlobal.disconnect()
        })
      }, { 
        threshold: 0.20,
        rootMargin: "0px 0px -10% 0px"
      })

      observadorGlobal.observe(contenedorXV.value)
    })

    onUnmounted(() => {
      if (observadorGlobal) observadorGlobal.disconnect()
      if (contextoGsap) contextoGsap.revert()
    })

    return { contenedorXV }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;1,400&family=Montserrat:wght@400;500;700&family=Great+Vibes&family=Alex+Brush&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600&display=swap');

.portada-arley {
  position: relative;
  width: 100%;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 80px 24px 10px;
  box-sizing: border-box;
}

/* FONDO (GRADIENTE Y ARCO) */
.fondo-gradiente {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: -2;
}

.fondo-arco {
  position: absolute;
  top: 15vh;
  left: 50%;
  transform: translateX(-50%);
  width: min(92vw, 360px);
  height: 80vh;
  border-radius: 180px 180px 0 0;
  z-index: -1;
}

/* 🌟 DESTELLO BLANCO RECTO VERTICAL */
.onda-luz-bg {
  position: absolute;
  top: 0;
  left: -50%;
  width: 200%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0) 45%,
    rgba(255, 255, 255, 0.9) 50%,
    rgba(255, 255, 255, 0) 55%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: -1;
  animation: barridoLuzVertical 5s infinite linear;
  pointer-events: none;
}

@keyframes barridoLuzVertical {
  0% { transform: translateX(-40%); }
  100% { transform: translateX(90%); }
}

/* 🌟 BLOQUE DE TEXTOS */
.bloque-agradecimiento-editorial {
  width: 100%;
  max-width: 440px;
  text-align: center;
  z-index: 5;
  margin: auto 0;
  display: flex;
  margin-top: 40px;
  flex-direction: column;
  align-items: center;
}

.texto-gratitud-padres {
  font-family: 'Playfair Display', serif;
  font-size: clamp(15px, 3.8vw, 18px);
  color: #2c2c2c;
  line-height: 1.6;
  margin: 0 0 20px 0;
  font-weight: 400;
  padding: 0 10px;
}

.separador-vintage-center {
  width: min(45vw, 150px);
  height: auto;
  object-fit: contain;
  margin-bottom: 20px;
  opacity: 0.85;
}

.bloque-nombres-padres {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-bottom: 25px;
}

.bloque-padrinos-bautizo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-top: 10px;
}

.titulo-padrinos {
  font-family: 'Playfair Display', serif;
  font-size: clamp(18px, 4.5vw, 22px);
  color: #536559;
  margin: 0 0 10px 0;
  font-weight: 600;
  letter-spacing: 1px;
}

.nombre-caligrafico {
  font-family: 'Playfair Display', serif;
  font-weight: 400;
  font-size: clamp(26px, 8vw, 32px) !important;
  color: #536559;
  margin: 0;
  letter-spacing: 1px;
  line-height: 1.2;
}

.conector-and {
  font-family: 'Playfair Display', serif;
  font-size: clamp(20px, 6vw, 24px) !important;
  color: #536559;
  margin: -2px 0;
  font-style: italic;
}

/* ELEMENTOS GRÁFICOS */
.flor-grande, .brillo {
  position: absolute;
  transform-origin: center;
  will-change: transform, opacity;
  object-fit: contain;
}

.flor-der-1 {
  top: -6vh; right: -8vw; z-index: 13;
  width: min(44vw, 220px) !important;
}

/* BRILLOS */
.brillo-izq-1 {
  top: -5px; left: -18vw; z-index: 0;
  width: 320px; opacity: 0.6;
}
.brillo-izq-2 {
  bottom: 28vh; left: 5vw; z-index: 4;
  width: 100px; opacity: 0.5;
}
.brillo-der-1 {
  top: 22vh; right: 6vw; z-index: 0;
  width: 110px; opacity: 0.6;
}
.brillo-der-2 {
  bottom: 7vh; right: -3vh; z-index: 4;
  width: 140px; opacity: 0.7;
}
</style>